export default function () {
  const widgetName = 'headerButtonWidget';
  const widgetOpts = headerButtonWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const noURL = data.items[0]?.URL !== null;
      const $item = $widgetHTML.find('.card-widget-item');
      if (hasData) {
        if (noURL) {
          $widgetHTML.find('a').attr('target', '_blank');
          $widgetHTML.clone().appendTo('.footer-navigation.top');
        } else {
          $item.removeAttr('href');
          $widgetHTML.addClass('no-link');
        }
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
